var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navbar'),_vm._m(0),(_vm.step==1)?_c('CartItems',{on:{"bankPaymentType":_vm.setBankPaymentType}}):_vm._e(),(_vm.step==2)?_c('CartInfo',{on:{"step":_vm.setStep}}):_vm._e(),_c('Footer')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slider"},[_c('div',{staticClass:"item"},[_c('h1',[_vm._v("سبد خرید")])])])
}]

export { render, staticRenderFns }